<div class="alert m-x-sm"
     [class.alert-info]="enrichedResponse.severity === ResponseDetailSeverity.Info"
     [class.alert-warning]="enrichedResponse.severity === ResponseDetailSeverity.Warning"
     [class.alert-danger]="enrichedResponse.severity === ResponseDetailSeverity.Error">
  <div class="header">
    <div class="title">
      <b>{{ enrichedResponse.responseCode || 'ERR' }}</b>
      <i *ngIf="enrichedResponse.targets?.length"> {{ enrichedResponse.targets.join(', ') }} </i>
    </div>
    <div class="lang-buttons">
      <button type="button" class="btn btn-link btn-xs btn-lang"
              *ngFor="let lang of languages.sort()"
              (click)="selectedLanguage = lang"
              [attr.data-lang]="lang"
              [class.active]="selectedLanguage === lang">
        {{ lang }}
      </button>
    </div>
  </div>
  <div class="messages"
       *ngIf="getDescription() as selected">
    <span>{{ selected.responseDescription }}</span>
    <ng-container *ngIf="selected.resolutionDescription">
      <br>
      <span>({{ selected.resolutionDescription }})</span>
    </ng-container>
  </div>
</div>
